import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Col, Row } from 'antd'
import { includes } from 'lodash-es'

import { Panel } from '../../../../core/components/styled'
import { getQueryParams } from '../../../../core/utils/services/queryParams'

import {
  MenuIsAwaitingScrapingFilter,
  MenuScrapedByFilter,
  MenuScrapingTypeFilter,
  MenuStatusFilter,
  SearchBrandFilter,
  SearchMenuFilter,
  TaskAssignedToFilter,
  TaskAwaitingReasonFilter,
  TaskIsAssignedFilter,
  TaskIsAwaitingFilter,
  TaskIsRerunFlowFilter,
  TaskIsVerifiedFilter,
  TaskReopenReasonFilter,
  TaskResolvedTypeFilter,
  TaskStatusFilter,
} from '../../../../common/components'
import {
  ADMIN,
  DEFINER_MIDDLE_SCRAPER_REVIEWER,
  DEFINER_SENIOR_SCRAPER_REVIEWER,
  MIDDLE_SCRAPER_REVIEWER,
  QUALITY_CHECKER_SENIOR_SCRAPER_REVIEWER,
  REVIEWER,
  SENIOR_SCRAPER_REVIEWER,
  TEAM_LEADER,
} from '../../../../common/constants'

import { MenuFormatFilter } from '../../../../menus/components/pages/sections'
import { REOPENED } from '../../../constants'

const DishReviewTasksFilters = () => {
  const { search } = useLocation()
  const { isAssigned, isAwaiting, statuses } = getQueryParams(search)

  const isReopenStatusSelected = useMemo(() => includes(statuses, REOPENED), [
    statuses,
  ])

  return (
    <Panel margin="small no">
      <Row gutter={16}>
        <Col span={6}>
          <SearchBrandFilter />
        </Col>
        <Col span={7}>
          <SearchMenuFilter />
        </Col>
      </Row>
      <Panel margin="small no">
        <Row gutter={[16, 16]}>
          <Col span={4}>
            <TaskStatusFilter />
          </Col>

          <Col span={5}>
            <TaskReopenReasonFilter disabled={!isReopenStatusSelected} />
          </Col>

          <Col span={2}>
            <TaskIsAssignedFilter />
          </Col>

          <Col span={3}>
            <TaskAssignedToFilter
              disabled={!isAssigned}
              roles={[
                ADMIN,
                TEAM_LEADER,
                DEFINER_MIDDLE_SCRAPER_REVIEWER,
                DEFINER_SENIOR_SCRAPER_REVIEWER,
                MIDDLE_SCRAPER_REVIEWER,
                REVIEWER,
                SENIOR_SCRAPER_REVIEWER,
                QUALITY_CHECKER_SENIOR_SCRAPER_REVIEWER,
              ]}
            />
          </Col>

          <Col span={2}>
            <TaskIsAwaitingFilter />
          </Col>

          <Col span={3}>
            <TaskAwaitingReasonFilter disabled={!isAwaiting} />
          </Col>

          <Col span={3}>
            <MenuIsAwaitingScrapingFilter />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={4}>
            <MenuFormatFilter mode="multiple" width="100%" />
          </Col>
          <Col span={5}>
            <MenuStatusFilter mode="multiple" />
          </Col>
          <Col span={3}>
            <MenuScrapingTypeFilter mode="multiple" />
          </Col>

          <Col span={5}>
            <MenuScrapedByFilter label="Scraped by" />
          </Col>

          <Col span={2}>
            <TaskResolvedTypeFilter />
          </Col>

          <Col span={2}>
            <TaskIsVerifiedFilter />
          </Col>

          <Col span={2}>
            <TaskIsRerunFlowFilter />
          </Col>
        </Row>
      </Panel>
    </Panel>
  )
}

export default DishReviewTasksFilters
